var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infor-detail"},[_c('div',{staticClass:"sign-header"},[_c('img',{attrs:{"src":_vm.detail.cover,"alt":""}})]),_c('div',{staticClass:"sign-body"},[_c('div',{staticClass:"sign-title"},[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticClass:"sign-content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }